import { render } from "./Company_Left.vue?vue&type=template&id=32a308b6"
import script from "./Company_Left.vue?vue&type=script&lang=js"
export * from "./Company_Left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__